module.exports = __webpack_public_path__ + "static/media/19-WaterHeatExchanger - DX cool - El heat.011955bd.png";